import { useTranslation } from 'react-i18next';
import { MarketingPage, Section } from './MarketingPage';

const PARTS = ['store', 'ai', 'who', 'guests', 'export', 'delete', 'contact'] as const;

/**
 * Written from what the app actually does — `docs/security.md` is the source,
 * not a template. Every claim here is one the code keeps:
 *
 * - guest phone numbers, emails and addresses never reach a text model
 * - the public wedding page carries no guest data at all
 * - an invitation link reads one household and nothing else
 * - export and delete already exist as endpoints
 *
 * It is a plain-language statement of practice, not legal advice, and it says so
 * — a real policy should be reviewed by somebody qualified before launch.
 */
export function Privacy() {
  const { t } = useTranslation();
  return (
    <MarketingPage title={t('marketing.privacy_.title')} lede={t('marketing.privacy_.lede')}>
      {PARTS.map((part) => (
        <Section key={part} heading={t(`marketing.privacy_.${part}.title`)}>
          <p className="whitespace-pre-line">{t(`marketing.privacy_.${part}.body`)}</p>
        </Section>
      ))}
      <p className="text-caption text-leaf-soft">{t('marketing.privacy_.notLegal')}</p>
    </MarketingPage>
  );
}
